module.exports = __webpack_public_path__ + "src/assets/models/micropipette/holder_3.fbx";